import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

// based on https://icons.app.sbb.ch/kom/chevron-up-small.svg
export const ChevronUp: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <polyline fill="none" stroke={iconColor} points="4 15.999 12 7.999 20 15.999" />
    </svg>
  );
};
